import {createReducer} from 'utils/redux';
import {SET_ACTIVE_PICKS_TAB, FOLLOWING_PICKS_TAB} from 'actions/ui';

const initialState = {
  activePicksTab: FOLLOWING_PICKS_TAB,
};

export default createReducer(initialState, {
  [SET_ACTIVE_PICKS_TAB]: (state, {payload: activePicksTab}) => ({...state, activePicksTab}),
});
